import {fulfilledState, pendingState, rejectedState, resError} from "@helpers";
import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import UsersService from "@services/UsersService";

export const viewUser = createAsyncThunk(
  "user/view",
  async ({id}, {rejectWithValue}) => {
    try {
      const response = await UsersService.viewUser({id});

      return response.data;
    } catch (err) {
      return rejectWithValue(resError(err));
    }
  },
);

export const archiveUser = createAsyncThunk(
  "user/archive",
  async ({id}, {rejectWithValue}) => {
    try {
      const response = await UsersService.archiveUser({id});

      return response.data;
    } catch (err) {
      return rejectWithValue(resError(err));
    }
  },
);

export const unArchiveUser = createAsyncThunk(
  "user/restore",
  async ({id}, {rejectWithValue}) => {
    try {
      const response = await UsersService.unArchiveUser({id});

      return response.data;
    } catch (err) {
      return rejectWithValue(resError(err));
    }
  },
);

export const deleteUser = createAsyncThunk(
  "user/delete",
  async ({id}, {rejectWithValue}) => {
    try {
      const response = await UsersService.deleteUser({id});

      return response.data;
    } catch (err) {
      return rejectWithValue(resError(err));
    }
  },
);

const initialState = {
  current: null,
  errors: null,
  error: "",
  status: "",
};

const viewUserSlice = createSlice({
  name: "view-user",
  initialState,
  reducers: {
    setCurrent(state, action) {
      state.current = action.payload;
    },
    setErrors(state, action) {
      state.errors = action.payload;
    },
    setError(state, action) {
      state.error = action.payload;
    },
    setStatus(state, action) {
      state.status = action.payload;
    },
    clearView() {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(viewUser.pending, (state) => {
        pendingState(state);
      })
      .addCase(viewUser.fulfilled, (state, action) => {
        state.current = action.payload;
        fulfilledState(state);
      })
      .addCase(viewUser.rejected, (state, action) => {
        rejectedState(state, action);
      })

      .addCase(archiveUser.pending, (state) => {
        pendingState(state);
      })
      .addCase(archiveUser.fulfilled, (state) => {
        fulfilledState(state);
      })
      .addCase(archiveUser.rejected, (state, action) => {
        rejectedState(state, action);
      })

      .addCase(unArchiveUser.pending, (state) => {
        pendingState(state);
      })
      .addCase(unArchiveUser.fulfilled, (state) => {
        fulfilledState(state);
      })
      .addCase(unArchiveUser.rejected, (state, action) => {
        rejectedState(state, action);
      })

      .addCase(deleteUser.pending, (state) => {
        pendingState(state);
      })
      .addCase(deleteUser.fulfilled, (state) => {
        fulfilledState(state);
      })
      .addCase(deleteUser.rejected, (state, action) => {
        rejectedState(state, action);
      });
  },
});

export const {clearView, setCurrent, setError, setStatus} =
  viewUserSlice.actions;
export default viewUserSlice.reducer;
